import React from 'react';
import { noop } from 'lodash-es';

import { Grid, GridItem } from 'common/components/Grid';
import ReCaptchaDisclaimer from 'common/components/ReCaptchaDisclaimer';
import { SectionName } from './enums';
import LinkSectionGroup from './LinkSectionGroup';
import type { LinkSectionDataProps } from './types';

interface GeneralOnlyFooterLinkSectionProps {
  section: LinkSectionDataProps;
}

const GeneralOnlyFooterLinkSection = ({ section }: GeneralOnlyFooterLinkSectionProps) => (
  <Grid pt={[null, null, 'sp_16']} as="nav">
    <GridItem pb="sp_16">
      <LinkSectionGroup
        data={section}
        sectionName={SectionName.General}
        onTitleClick={noop}
        isCollapsible={false}
        isExpanded
        isInline
      />
      <ReCaptchaDisclaimer />
    </GridItem>
  </Grid>
);

export default GeneralOnlyFooterLinkSection;
